/**
 * Catalog bits the widgets branch on by name rather than by number. Only the rows a section is
 * already written for are named here; the rest stay numbers until they get one.
 */
export const ATTENTION_STATUS_BITS = {
  /** `Offering X is not fully acknowledged` — the acknowledgment section's row. */
  acknowledgment: 16,
  /** `Offering X is not planned` — the completeness section's row. */
  planned: 1,
  /** `FinSob Plan is not good` — the FinSob plan-quality section's row. */
  finSobQuality: 2,
  /** `Initiatives Plan is not good` — the initiatives plan-quality section's row. */
  initiativesQuality: 4,
  /** `MDF is not planned` — the MDF section's row. */
  mdf: 8,
  /** `SOB Actuals are missing` — the SOB actuals section's row. */
  sobActuals: 32,
  /** `Offering X is not reviewed for H2` — the H2 review section's row. */
  h2Review: 64,
  /** `Specific program risk` — the programme risk section's row. */
  programRisk: 256,
  /** `QX plan is not achieved` — the quarter performance section's row. */
  quarterPlan: 512,
  /** `Partner is not eligible for MDF` — shares the acknowledgment section, as the sheet says. */
  mdfEligibility: 128,
  /** `My pending actions` — the pending-actions section's row. */
  pendingActions: 1024,
} as const
